module.exports = {"231225100":"明水镇","231225101":"兴仁镇","231225102":"永兴镇","231225103":"崇德镇","231225104":"通达镇","231225201":"双兴乡","231225203":"永久乡","231225204":"树人乡","231225205":"光荣乡","231225206":"繁荣乡","231225207":"通泉乡","231225208":"育林乡","231225400":"国营林场","231225580":"县联社马场","231225581":"明水种畜场","231225582":"育林畜牧场","231225583":"国营第一良种","231225584":"国营第二良种","231225585":"国营第三良种"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231225.json
// module id = 737
// module chunks = 0